import React from 'react';
import * as types from '../types';
import { connect } from 'react-redux'
import { SocketModal } from "@components/layout/socket-modal";
import {OrderDetailsContainer} from '@components/orders/modals/order-details/order-details.container';

class SocketModalManager extends React.Component {
    render () {
        let { open, data } = this.props.socketModal;
        if (open) {
            switch (data.type) {
                case types.TYPE_ORDER_DETAILS: return <OrderDetailsContainer
                    open={true}
                    disableOpenButton
                    orderId={data.order_id}
                    onClose={this.props.closeModal}
                />;
                default: return null
            }
        }
        return null;
    }
}

const mapStateToProps = (state, props) => ({
    socketModal: state.layout.socketModal || { open: false },
});

const actions = {
    closeModal: SocketModal.actions.closeModal,
};

export default connect(mapStateToProps, actions)(SocketModalManager);
